import Vue from 'vue'
import store from './store'
import Router from 'vue-router'
import wx from './plugin/wxjssdk'
import progress from './plugin/progress'
import handleWxUrl from './handler/wx.sdk.handler/wx.path.handler'
import './tracker/baiduTracker'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/home',
      name: 'home_page',
      component: () => import('@/views/home/home')
    },
    {
      path: '/store',
      name: 'store_page',
      meta: {
        // 缓存页面配置
        keepAlive: true
      },
      component: () => import('@/views/store/store')
    },
    {
      path: '/qrcode',
      name: 'qrcode_page',
      component: () => import('@/views/qrcode/qrcode')
    },
    {
      path: '/auth',
      name: 'auth_page',
      component: () => import('@/views/auth')
    },
    {
      path: '/',
      name: 'home_page',
      component: () => import('@/views/home/home')
    }
  ]
})

router.beforeEach((to, from, next) => {
  progress.start()
  document.title = to.meta.title || '迪卡侬'
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  // 针对微信认证特殊处理（登录状态下返回AUTH页面）
  if (to.name === 'auth_page') {
    const env = window.__wxjs_environment
    const loginStatus = store.getters['user/loginStatus']
    if (loginStatus === 1) {
      env !== 'miniprogram' && wx.closeWindow()
      env === 'miniprogram' && wx.miniProgram.navigateBack()
    } else {
      next()
    }
  } else {
    next()
  }
})

router.afterEach((to, from, next) => {
  progress.done()
  // 劫持公共参数
  if (to.query.channel) {
    store.commit('channel/setChannel', to.query.channel)
  }

  // 微信回跳处理
  handleWxUrl(to)
})

export default router
